import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import DeploymentRequests from 'app/requests/Deployment/Deployment.requests'

const useGetDeployment = (id) => {
    return useRequest({
        key: RequestKeys.getDeployment,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(DeploymentRequests.get),
        enabled: Boolean(id),
    })
}

export default useGetDeployment
